import React from 'react';

import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import RulesPanel from './RulesPanel';
import ConfigurePanel from './ConfigurePanel';
// import RunTimePanel from './RunTimePanel';

import * as classes from './ReportTabPane.module.css';

const StyledTabs = withStyles({
    indicator: {
        backgroundColor: 'black',
    },
})(Tabs);

const StyledTab = withStyles((theme) => ({
    root: {
        fontSize:      theme.typography.pxToRem(22),
        textTransform: 'none',
        minWidth:      72,
        fontWeight:    theme.typography.fontWeightRegular,
        marginRight:   theme.spacing(4),
        fontFamily:    [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
            color:   'black',
            opacity: 1,
        },
        '&$selected': {
            color:      'black',
            fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
            color: 'black',
        },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);

const ReportTabPane = ({
    bobLoading,
    getOccupiedHoursList,
    isRunTimeDataValid,
    minFaultHours,
    runTimeData,
    selectedEquipment,
    selectedSystems,
    selectedRules,
    setMinFaultHours,
    selectedSpaceAirSensors,
    selectedOutsideAirSensors,
    selectedOccupanyStatusSensors,
    setSelectedRules,
    selectedState,
    selectedStateItems,
    setSelectedState,
    setSelectedStateItems,
    setSelectedSpaceAirSensors,
    setSelectedOutsideAirSensors,
    setSelectedOccupanyStatusSensors,
    spaceAirSensorData,
    setRunTimeData,
    outsideAirSensorData,
    objectsToMonitor,
    setObjectsToMonitor,
    aggregate,
    setAggregate,
    occupancyAggregate,
    setOccupancyAggregate,
    rulesTabDataState,
    setRulesTabDataState,
    runTimeTabDataState,
    setRunTimeTabDataState,
    selectState,
    setSelectState,
    activeRadioButton,
    setActiveRadioButton,
    ...props
}) => {
    const [value, setValue] = React.useState(process.env.reportRulesEnabled ? 0 : 1);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <React.Fragment>
            <div className={classes.TabContainer}>
                <StyledTabs value={value} onChange={handleChange} aria-label="styled tabs example">
                    {
                        process.env.reportRulesEnabled ?
                            <StyledTab value={0} label="Rules" />
                            :
                            null
                    }
                    <StyledTab value={1} label="Configure" />
                    {/* <StyledTab value={2} label="Run Time" /> */}
                </StyledTabs>
            </div>
            <div style={{height: '100%'}}>
                {
                    value === 0 ?
                        bobLoading.includes('fetchEntityRules') ?
                            <div className={classes.LoadingContainer}>
                                <img className={classes.Loader} src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                            </div>
                            :
                            <RulesPanel
                                minFaultHours={minFaultHours}
                                selectedEquipment={selectedEquipment}
                                selectedSystems={selectedSystems}
                                selectedRules={selectedRules}
                                setSelectedRules={setSelectedRules}
                                selectedState={selectedState}
                                selectedStateItems={selectedStateItems}
                                setMinFaultHours={setMinFaultHours}
                                setSelectedState={setSelectedState}
                                setSelectedStateItems={setSelectedStateItems}
                                rulesTabDataState={rulesTabDataState}
                                setRulesTabDataState={setRulesTabDataState}
                            />
                        :
                        value === 1 ?
                            bobLoading.includes('fetchEntitySensors') ?
                                <div className={classes.LoadingContainer}>
                                    <img className={classes.Loader} src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                                </div>
                                :
                                <ConfigurePanel
                                    selectedEquipment={selectedEquipment}
                                    selectedSystems={selectedSystems}
                                    selectedRules={selectedRules}
                                    selectedSpaceAirSensors={selectedSpaceAirSensors}
                                    selectedOutsideAirSensors={selectedOutsideAirSensors}
                                    setSelectedRules={setSelectedRules}
                                    selectedState={selectedState}
                                    selectedStateItems={selectedStateItems}
                                    setSelectedState={setSelectedState}
                                    setSelectedStateItems={setSelectedStateItems}
                                    setSelectedSpaceAirSensors={setSelectedSpaceAirSensors}
                                    setSelectedOutsideAirSensors={setSelectedOutsideAirSensors}
                                    spaceAirSensorData={spaceAirSensorData}
                                    outsideAirSensorData={outsideAirSensorData}
                                />
                            :
                            null
                }
                {/* {
                    value === 2 ?
                        bobLoading.includes('fetchEntitySensors') ?
                            <div className={classes.LoadingContainer}>
                                <img className={classes.Loader} src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                            </div>
                            :
                            <RunTimePanel
                                getOccupiedHoursList={getOccupiedHoursList}
                                isRunTimeDataValid={isRunTimeDataValid}
                                runTimeData={runTimeData}
                                selectedEquipment={selectedEquipment}
                                selectedSystems={selectedSystems}
                                selectedRules={selectedRules}
                                selectedSpaceAirSensors={selectedSpaceAirSensors}
                                selectedOutsideAirSensors={selectedOutsideAirSensors}
                                selectedOccupanyStatusSensors={selectedOccupanyStatusSensors}
                                setSelectedRules={setSelectedRules}
                                selectedState={selectedState}
                                selectedStateItems={selectedStateItems}
                                setSelectedState={setSelectedState}
                                setSelectedStateItems={setSelectedStateItems}
                                setSelectedSpaceAirSensors={setSelectedSpaceAirSensors}
                                setSelectedOutsideAirSensors={setSelectedOutsideAirSensors}
                                setSelectedOccupanyStatusSensors={setSelectedOccupanyStatusSensors}
                                spaceAirSensorData={spaceAirSensorData}
                                setRunTimeData={setRunTimeData}
                                outsideAirSensorData={outsideAirSensorData}
                                objectsToMonitor={objectsToMonitor}
                                setObjectsToMonitor={setObjectsToMonitor}
                                aggregate={aggregate}
                                setAggregate={setAggregate}
                                occupancyAggregate={occupancyAggregate}
                                setOccupancyAggregate={setOccupancyAggregate}
                                selectState={selectState}
                                setSelectState={setSelectState}
                                activeRadioButton={activeRadioButton}
                                setActiveRadioButton={setActiveRadioButton}
                                runTimeTabDataState={runTimeTabDataState}
                                setRunTimeTabDataState={setRunTimeTabDataState}
                            />
                        : null
                } */}
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    bobLoading: state.bob.bobLoading
});

export default connect(mapStateToProps, null)(ReportTabPane);
